import { type GlobalStoreStateConfiguration } from '@/stores/globalStore';

// `/stock/{vin}/configuration` returns `prices.p11dPrice`, which the legacy
// stock configuration type doesn't declare.
type StockP11dPrices = { p11dPrice?: { value?: string | null } | null };

const getStockBaseP11dPrice = (
  configuration: GlobalStoreStateConfiguration
): number | null => {
  const prices = configuration.stockData?.prices as StockP11dPrices | undefined;
  const value = Number(prices?.p11dPrice?.value);

  return prices?.p11dPrice?.value != null && Number.isFinite(value)
    ? value
    : null;
};

// The PDB's `p11dPrice` for VIN stock cars nets off grants and leaves out
// bespoke options, so it disagrees with the Showroom Companion. Rebuild it from
// the stock base P11D plus the positive factory and bespoke extras instead.
export const getP11dPrice = (
  configuration: GlobalStoreStateConfiguration | undefined
): number | null | undefined => {
  if (!configuration) return undefined;

  const pdbP11dPrice = configuration.pdbData?.pricing?.p11dPrice;
  if (!configuration.vin) return pdbP11dPrice;

  const stockBaseP11dPrice = getStockBaseP11dPrice(configuration);
  const factoryAndBespokeExtras =
    configuration.pdbData?.pricing?.factoryAndBespokeExtras;

  if (stockBaseP11dPrice == null || factoryAndBespokeExtras == null) {
    return pdbP11dPrice;
  }

  return (
    Math.round((stockBaseP11dPrice + Number(factoryAndBespokeExtras)) * 100) /
    100
  );
};
